import script from "./CustomerDelivery.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerDelivery.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerDelivery.vue?vue&type=style&index=0&id=3396ab98&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3396ab98"]])

export default __exports__